import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=47c04c09&lang=pug&"
import script from "./Success.vue?vue&type=script&lang=ts&"
export * from "./Success.vue?vue&type=script&lang=ts&"
import style0 from "./Success.vue?vue&type=style&index=0&id=47c04c09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports